import React, { Component } from "react";
import { NavBar, Footer } from "../components/ReusableElements";
import Fade from "react-reveal/Fade";

export default class About extends Component {
  constructor() {
    super();

    this.state = {};
  }

  render() {
    return (
      <div className="About">
        <NavBar
          isLoggedIn={this.props.isLoggedIn}
          logout={this.props.toggleIsLoggedIn}
        />
        <div className="about-box">
          <Fade bottom>
            <h1 className="about-title">
              What is the Carousell Rights Owners Programme?
            </h1>
            <br></br>
            <div className="about-description">
              At Carousell, we strongly respect intellectual property rights and
              are committed to providing a safe platform for the selling and
              buying of goods and products. As we follow the yellow brick road,
              we have established a programme called “Carousell Rights Owner
              Programme (CROP)”, which provides a platform for:
              <br></br>
              <div>
                <ul style={{ textAlign: "left", lineHeight: "1.5" }}>
                  <li>
                    partner brands to expedite the process of removing
                    infringing content and reduce the resources required to
                    communicate to sellers that dispute the takedown for
                    intellectual property infringements;{" "}
                  </li>
                  <li>
                    partner brands to communicate their intellectual property
                    policies to our users; and
                  </li>
                  <li>
                    establishing a knowledge bank through which Carousell users
                    can better understand a brand’s legal position on infringing
                    materials and be in a better position to make an informed
                    decision when purchasing a product.
                  </li>
                </ul>
              </div>
              <br></br>
              As one of our favourite brands, we would like to invite you to
              take part in our pilot CROP. In doing so, we can better educate
              Carousell users, expedite the infringement reporting process for
              both users and brands and preserve the integrity of your brand.
              <br></br>
              <br></br>
              Currently participating brands include Nike, Gucci, Grab, Bottega,
              Yves Saint Laurent and more.
              {
                // <h2 className="about-title">Our partner brands</h2>
                // <div className="logo-container">
                //     {/** brands here... TODO: make this dynamic and grid */}
                //     <div className="logo-row">
                //         <a href={require("../assets/docs/zula.pdf")} target="_blank">
                //             <img width="100" height="100" src={require(`../assets/logos/zula.jpg`)}/>
                //         </a>
                //         <img width="100" height="100" src={require(`../assets/logos/zula.jpg`)}/>
                //         <img width="100" height="100" src={require(`../assets/logos/zula.jpg`)}/>
                //     </div>
                //     <div className="logo-row">
                //         <img width="100" height="100" src={require(`../assets/logos/zula.jpg`)}/>
                //         <img width="100" height="100" src={require(`../assets/logos/zula.jpg`)}/>
                //         <img width="100" height="100" src={require(`../assets/logos/zula.jpg`)}/>
                //     </div>
                // </div>
              }
            </div>
          </Fade>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/About.js